export enum MaterialDriedByType {
  Air = 'Air',
  Oven = 'Oven',
  Natural = 'Natural',
}

/**
 * Determines the used sub samples
 */
export enum UsedSubSamples {
  Single = 'Single',
  Multiple = 'Multiple',
}

/**
 * Determines whether the user is wetting or drying the sample
 */
export enum SampleMoisture {
  Increasing = 'Increasing',
  Decreasing = 'Decreasing',
}

/**
 * Indicates the algorithm used to fit a curve to a series of data points
 */
export enum CurveFittingAlgorithm {
  /**
   * Curve is constructed by forming a Bézier curve between each pair of data points, with control points determined so that the curves meet smoothly
   */
  Bezier = 'Bezier',
  /**
   *  Curve is constructed as a cubic spline passing through the data points
   */
  CubicSpline = 'CubicSpline',
  /**
   *  Curve is constructed as a linear interpolation through the data points
   */
  Linear = 'Linear',
}
